import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=a939bb8a&scoped=true"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"
import style0 from "./Events.vue?vue&type=style&index=0&id=a939bb8a&prod&lang=css"
import style1 from "./Events.vue?vue&type=style&index=1&id=a939bb8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a939bb8a",
  null
  
)

export default component.exports